<template>
  <div class="item" @click.capture="showModal">
    <div v-if="product.PhotoUrl" class="item-img">
      <div
        v-lazy:background-image="product.PhotoUrl"
        class="product-div-img"
        :style="imageRatioStyle"
      >
      <div class="triangle-container">
          <div
            class="triangle-topright-img"
            v-if="product.Status == 3 || product.Status == 2||product.Status == 1"
            :class="{
            'triangle-topright-img-popular':product.Status == 2,
            'triangle-topright-img-sold':product.Status == 3,
            'triangle-topright-img-new':product.Status == 1
            }"
          >
            <span>{{ product.Status | formatStatus(this) }}</span>
          </div>
      </div>
    </div>
    </div>
    <div v-else>
      <div class="triangle-container">
        <div
          class="triangle-topright-noimg"
          v-if="product.Status == 3 || product.Status == 2||product.Status == 1"
          :class="{
          'triangle-topright-img-popular':product.Status == 2,
          'triangle-topright-img-sold':product.Status == 3,
          'triangle-topright-img-new':product.Status == 1
          }"
        >
          <span>{{ product.Status | formatStatus(this) }}</span>
        </div>
      </div>
    </div>
    <div class="item-details ">
      <h2 class="item-title">{{ category.Name }}</h2>
      <p v-html="product.ShortDescription" class="block-with-text-mobile"></p>
    </div>
    <div class="item-price d-flex">
      <h2>{{ category.Price | formatMoney(currencySign) }}</h2>
      <ul>
        <li
          v-for="(dietary, index) in dietaryList"
          :key="index"
          :style="getIconStyle(dietary)"
          :title="dietary.Name"
        ></li>
      </ul>
    </div>
    <div v-if="product.Status == 3" class="sold-out">
      <h4></h4>
    </div>
    <AddToCart
      v-if="isModalVisible"
      :price="category.Price"
      :product-id="category.ProductID"
      :category="category"
      :parent-category="parentCategory"
      :product="product"
      :modifiers="modifiers"
      :image-styles="dialogImageRatioStyle"
    />
  </div>
</template>

<script>
import AddToCart from "./AddToCartMobile";
import shared from "../../../sharedscripts/shop/products/Product.js";
export default {
  name: "Product",
  components: { AddToCart },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    parentCategory: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    sectionId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0
    };
  },
  computed: {
    ...shared.computed
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods
  }
};
</script>